export const AGENT_TYPES = {
    TEXT: 'TEXT',
    IMAGE: 'IMAGE',
    ARCHIVES: 'ARCHIVES',
    SEARCH_WEB: 'SEARCH_WEB',
    ZONE_CONTEXT: 'ZONE_CONTEXT'
};

export const PROVIDERS = {
    OPENAI: 'OPENAI',
    ANTHROPIC: 'ANTHROPIC',
    AZURE: 'AZURE',
    GEMINI: 'GEMINI',
    PERPLEXITY: 'PERPLEXITY',
    CUSTOM: 'CUSTOM'
};

export const INTELLIGENCE_LEVELS = {
    LOW: 'LOW',
    MEDIUM: 'MEDIUM',
    HIGH: 'HIGH'
};

export const PROVIDER_OPTIONS = [
    { label: 'OpenAI', value: PROVIDERS.OPENAI },
    { label: 'Anthropic', value: PROVIDERS.ANTHROPIC },
    { label: 'Perplexity', value: PROVIDERS.PERPLEXITY },
    { label: 'Azure', value: PROVIDERS.AZURE },
    { label: 'Gemini', value: PROVIDERS.GEMINI },
    { label: 'Custom', value: PROVIDERS.CUSTOM }
];

export const TYPE_OPTIONS = [
    { label: 'Texto', value: AGENT_TYPES.TEXT },
    { label: 'Imagem', value: AGENT_TYPES.IMAGE },
    { label: 'Arquivos', value: AGENT_TYPES.ARCHIVES },
    { label: 'Busca Web', value: AGENT_TYPES.SEARCH_WEB },
    { label: 'Contexto da Zona', value: AGENT_TYPES.ZONE_CONTEXT }
];

export const PROVIDER_SUPPORTED_TYPES = {
    [PROVIDERS.OPENAI]: [AGENT_TYPES.TEXT, AGENT_TYPES.IMAGE, AGENT_TYPES.ARCHIVES, AGENT_TYPES.ZONE_CONTEXT],
    [PROVIDERS.ANTHROPIC]: [AGENT_TYPES.TEXT, AGENT_TYPES.ZONE_CONTEXT],
    [PROVIDERS.PERPLEXITY]: [AGENT_TYPES.SEARCH_WEB],
    [PROVIDERS.AZURE]: [AGENT_TYPES.TEXT, AGENT_TYPES.ZONE_CONTEXT],
    [PROVIDERS.GEMINI]: [AGENT_TYPES.TEXT, AGENT_TYPES.ZONE_CONTEXT],
    [PROVIDERS.CUSTOM]: [AGENT_TYPES.IMAGE]
};

export const INTELLIGENCE_OPTIONS = [
    {
        value: INTELLIGENCE_LEVELS.LOW,
        label: 'Rápido',
        description: 'Respostas mais rápidas e econômicas.',
        icon: 'pi pi-bolt'
    },
    {
        value: INTELLIGENCE_LEVELS.MEDIUM,
        label: 'Equilibrado',
        description: 'Equilíbrio entre velocidade e profundidade.',
        icon: 'pi pi-sliders-h',
        recommended: true
    },
    {
        value: INTELLIGENCE_LEVELS.HIGH,
        label: 'Profundo',
        description: 'Mais contexto para análises complexas.',
        icon: 'pi pi-star'
    }
];

const INTELLIGENCE_BY_MODEL = {
    'gpt-5-mini': INTELLIGENCE_LEVELS.LOW,
    'gpt-5': INTELLIGENCE_LEVELS.MEDIUM,
    'gpt-5.3': INTELLIGENCE_LEVELS.HIGH,
    'gpt-5.4': INTELLIGENCE_LEVELS.HIGH,
    'claude-haiku-4-5': INTELLIGENCE_LEVELS.LOW,
    'claude-sonnet-4-5': INTELLIGENCE_LEVELS.MEDIUM,
    'claude-opus-4-5': INTELLIGENCE_LEVELS.HIGH,
    sonar: INTELLIGENCE_LEVELS.LOW,
    'sonar-pro': INTELLIGENCE_LEVELS.MEDIUM
};

export const getTypeOptionsForProvider = (provider) => {
    const supportedTypes = PROVIDER_SUPPORTED_TYPES[provider] || [];
    return TYPE_OPTIONS.filter((option) => supportedTypes.includes(option.value));
};

export const isTypeSupportedByProvider = (provider, type) => {
    return (PROVIDER_SUPPORTED_TYPES[provider] || []).includes(type);
};

export const getAgentIntelligenceLevel = (agent) => {
    return agent?.intelligenceLevel
        || agent?.config?.intelligenceLevel
        || INTELLIGENCE_BY_MODEL[agent?.model]
        || INTELLIGENCE_LEVELS.LOW;
};

export const getIntelligenceLevelLabel = (level) => ({
    [INTELLIGENCE_LEVELS.LOW]: 'Rápido',
    [INTELLIGENCE_LEVELS.MEDIUM]: 'Equilibrado',
    [INTELLIGENCE_LEVELS.HIGH]: 'Profundo'
}[level] || level);

export const getTypeLabel = (type) => TYPE_OPTIONS.find((option) => option.value === type)?.label || type;

export const formatBytes = (bytes = 0) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(2)} MB`;
};
